import script from "./Teams.vue?vue&type=script&setup=true&lang=js"
export * from "./Teams.vue?vue&type=script&setup=true&lang=js"

import "./Teams.vue?vue&type=style&index=0&id=2d2517fb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2517fb"]])

export default __exports__